export const Footer = () => (
  <footer className="relative z-10 border-t-4 border-gray-300 bg-black/90 backdrop-blur-sm py-8 px-4">
    <div className="max-w-7xl mx-auto text-center">
      <p className="text-lg sm:text-xl font-black game-show-text mb-2">
        THIS IS A GAME SHOW
      </p>
      <p className="text-gray-400 font-bold">
        © 2024 CiroGameShow. All rights reserved.
      </p>
    </div>
  </footer>
);
